/**

Coded by www.techhighway.ca

*/

/**
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav  .

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav.
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts

import Permission from "layouts/permission";
import UserManagement from "layouts/user-management";
import UserProfile from "layouts/user-profile";

import { Divider } from "@mui/material";
import ManageAuctionListing from "layouts/active-listings";
import ManageInActiveAuctionListing from "layouts/closed-listings";
import ManageParameter from "layouts/manage-parameters";
import ManageStatus from "layouts/manage-statuses";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="medium">dashboard</Icon>,
  //   route: "/dashboard",
  //   order: 101,
  //   component: <Dashboard />,
  // },
  // {
  //   type: "divider",
  //   name: "",
  //   key: "div-1",
  //   icon: "",
  //   route: "",
  //   order: 102,
  //   component: <Divider />,
  // },
  {
    type: "collapse",
    name: "Manage Auction Listings",
    key: "auction-listing",
    icon: <Icon fontSize="medium">monetization_on_icon</Icon>,
    order: 104,
    collapse: [
      {
        type: "collapse",
        name: "Active Listings",
        key: "active-listings",
        icon: <Icon fontSize="medium">fact_check_icon</Icon>,
        route: "/active-listings",
        order: 105,
        component: <ManageAuctionListing />,
      },
      {
        type: "collapse",
        name: "Closed Listings",
        key: "closed-listings",
        icon: <Icon fontSize="medium">delete_sweep_icon</Icon>,
        route: "/closed-listings",
        order: 106,
        component: <ManageInActiveAuctionListing />,
      },
    ],
  },
  {
    type: "divider",
    name: "",
    key: "div-2",
    icon: "",
    route: "",
    order: 105,
    component: <Divider />,
  },
  {
    type: "collapse",
    name: "Setup",
    key: "set-up",
    heading: 1,
    order: 110,
    icon: <Icon fontSize="medium">handyman_icon</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Statuses",
        key: "manage-statuses",
        icon: <Icon fontSize="medium">security_icon</Icon>,
        route: "/manage-statuses",
        order: 263,
        component: <ManageStatus />,
      },
      {
        type: "collapse",
        name: "Parameters",
        key: "manage-parameters",
        icon: <Icon fontSize="medium">settings_suggest_icon</Icon>,
        route: "/manage-parameters",
        order: 111,
        component: <ManageParameter />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Access Management",
    key: "access-management",
    heading: 1,
    order: 120,
    icon: <Icon fontSize="medium">accessibility_icon</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "My Profile",
        key: "user-profile",
        icon: <Icon fontSize="medium">person</Icon>,
        route: "/user-profile",
        order: 121,
        component: <UserProfile />,
      },
      {
        type: "collapse",
        name: "Users",
        key: "user-management",
        icon: <Icon fontSize="medium">list</Icon>,
        route: "/user-management",
        order: 122,
        component: <UserManagement />,
      },
      {
        type: "collapse",
        name: "Permissions",
        key: "permission",
        icon: <Icon fontSize="medium">lock_open</Icon>,
        route: "/permission",
        order: 123,
        component: <Permission />,
      },
    ],
  },
];

export default routes;
